import React from "react";
import styles from "./ExploreBottomBar.module.scss";

const ExploreBottomBar = ({ count, onClick, zoomRequired }) => {
  if (zoomRequired) {
    return (
      <div className={styles.container}>
        <div className={styles.zoomToast}>
          <CircleExclamationIcon />
          <span className={styles.zoomText}>매물을 보려면 지도를 확대해 주세요.</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <button type="button" className={styles.button} onClick={onClick}>
        <span className={styles.text}>
          <span className={styles.label}>현재위치 매물 </span>
          <span className={styles.count}>{count != null ? `${count}개` : ""}</span>
        </span>
        <ChevronRightIcon />
      </button>
    </div>
  );
};

const ChevronRightIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CircleExclamationIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11" cy="11" r="11" fill="#FF6363"/>
    <path d="M11 6V12.5" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="11" cy="15.5" r="1.25" fill="white"/>
  </svg>
);

export default ExploreBottomBar;
